module.exports = __webpack_public_path__ + "img/55.64580a0a.png";